import React from 'react';
import * as Icons from 'lucide-react';
import { Reveal } from '../Reveal';
import { coach } from '../../config/coach';

const WhatYouGetSection = () => {
  const { kicker, heading, sub, features } = coach.whatYouGet;

  return (
    <section id="what-you-get" className="relative bg-black py-24 sm:py-32" data-testid="what-you-get-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Photo — head fully visible (object-top), grayscale editorial */}
          <div className="lg:col-span-5">
            <Reveal>
              <div className="relative w-full aspect-[4/5] overflow-hidden rounded-2xl border border-white/10">
                <img
                  src={coach.images.whatYouGet}
                  alt={`${coach.fullName} conditioning`}
                  className="w-full h-full object-cover object-[50%_12%] img-grade"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
              </div>
            </Reveal>
          </div>

          {/* Header + cards */}
          <div className="lg:col-span-7">
            <Reveal><span className="kicker">{kicker}</span></Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display font-bold uppercase text-white tracking-tight leading-[0.9] text-5xl sm:text-6xl lg:text-7xl mt-5">
                {heading}
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-5 text-white/60 text-base sm:text-lg max-w-lg">{sub}</p>
            </Reveal>

            <div className="mt-10 grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10 rounded-2xl overflow-hidden">
              {features.map((f, i) => {
                const Icon = Icons[f.icon] || Icons.Dumbbell;
                return (
                  <Reveal key={i} delay={i * 0.05} className="h-full">
                    <div
                      className="group h-full bg-[#0a0a0a] hover:bg-white/[0.04] transition-colors duration-500 p-6 sm:p-7"
                      data-testid={`feature-card-${i}`}
                    >
                      <div className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center mb-5 group-hover:border-white/40 transition-colors duration-500">
                        <Icon className="w-5 h-5 text-white" strokeWidth={1.6} />
                      </div>
                      <h3 className="font-display uppercase tracking-wide text-white text-xl mb-2">{f.title}</h3>
                      <p className="text-white/55 text-sm leading-relaxed">{f.desc}</p>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatYouGetSection;
